// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__XEJmj","right":"Footer_right__1BK3U","buttons":"Footer_buttons__L1yCJ"};